import { DialogActions, Heading, Paragraph, Popover, Popper, Spacer, TextButton } from '@zillow/constellation';
import { CONDITIONAL_APPROVAL_URL } from '../../constants/urls';

export function ConditionalApprovalPopper({ ...props }) {
  return (
    <Spacer {...props} onClick={(e: React.MouseEvent) => e.stopPropagation()}>
      <Popper
        triggered={
          <Popover
            renderHeader={<Heading level={2}>Your application is still under review</Heading>}
            renderBody={
              <>
                <Paragraph>
                  For your protection, local law requires landlords to conditionally approve applications before they
                  can view the criminal history section of your background report.
                </Paragraph>
                <DialogActions>
                  <TextButton as="a" href={CONDITIONAL_APPROVAL_URL} target="_blank">
                    Learn more
                  </TextButton>
                </DialogActions>
              </>
            }
          />
        }
      />
    </Spacer>
  );
}
